import errorTrackingService from './errorTrackingService';

function isChunkLoadError(err) {
  try {
    if (!err) return false;
    const name = err.name || '';
    const msg = String(err.message || err.toString() || '');
    return (
      name === 'ChunkLoadError' ||
      msg.includes('ChunkLoadError') ||
      msg.includes('Loading chunk') ||
      (msg.toLowerCase().includes('chunk') && msg.toLowerCase().includes('failed'))
    );
  } catch (_) {
    return false;
  }
}

function recoverFromChunkError(source) {
  try {
    if (typeof window === 'undefined') return;
    const RELOAD_GUARD = '__chunk_error_recovered__';

    // If we've already tried reloading once this session, avoid loops.
    if (sessionStorage.getItem(RELOAD_GUARD)) {
      // As a best-effort, clear persisted Redux state which might reference old assets
      try { localStorage.removeItem('persist:root'); } catch (_) {}
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('[ChunkLoadError] occurred again after reload. Persistence cleared. Please hard refresh. Source:', source);
      }
      return;
    }

    sessionStorage.setItem(RELOAD_GUARD, '1');

    // Reload with a cache-busting query param to avoid stale assets
    const url = new URL(window.location.href);
    url.searchParams.set('v', String(Date.now()));
    window.location.replace(url.toString());
  } catch (_) {
    // Fallback reload
    try { window.location.reload(); } catch (__) {}
  }
}

export default function setupGlobalErrorHandlers() {
  try {
    if (typeof window === 'undefined') return;
    if (window.__GLOBAL_ERROR_HANDLERS_INSTALLED__) return;
    window.__GLOBAL_ERROR_HANDLERS_INSTALLED__ = true;

    window.addEventListener('error', (event) => {
      try {
        const err = event?.error || new Error(event?.message || 'Unknown window error');
        errorTrackingService.log(err, {
          source: 'window.error',
          filename: event?.filename,
          lineno: event?.lineno,
          colno: event?.colno,
        });
        if (isChunkLoadError(err)) {
          recoverFromChunkError('window.error');
        }
      } catch (_) {}
    });

    window.addEventListener('unhandledrejection', (event) => {
      try {
        const reason = event?.reason;
        const err = reason instanceof Error ? reason : new Error(typeof reason === 'string' ? reason : JSON.stringify(reason));
        errorTrackingService.log(err, {
          source: 'window.unhandledrejection'
        });
        if (isChunkLoadError(err)) {
          recoverFromChunkError('window.unhandledrejection');
        }
      } catch (_) {}
    });

    if (process.env.NODE_ENV !== 'production') {
      console.log('[GlobalErrorHandlers] installed');
    }
  } catch (_) {}
}
